import React, { useState } from 'react';
import icon1 from '../../assets/services/digital transform.png'
import icon1h from '../../assets/services/digital transform white.png'
import icon2 from '../../assets/services/automation.png'
import icon2h from '../../assets/services/automation white.png'
import icon3 from '../../assets/services/data analytics.png'
import icon3h from '../../assets/services/data analytics white.png'
import icon4 from '../../assets/services/application develepment.png'
import icon4h from '../../assets/services/application develepment white.png'
import icon5 from '../../assets/services/mobile app.png'
import icon5h from '../../assets/services/mobile app white.png'
import icon6 from '../../assets/services/devops.png'
import icon6h from '../../assets/services/devops white.png'
import "@fontsource/manrope";
import "@fontsource/syne";
import { Element } from 'react-scroll';

const services = [
  {
    num: '01',
    icon: icon1,
    iconHover: icon1h,
    title: 'Digital Transformation',
    desc: 'Process Transformation, Business Model Transformation, Bringing in Nextgen Technology.',
  },
  {
    num: '02',
    icon: icon2,
    iconHover: icon2h,
    title: 'Quality Engineering and Automation',
    desc: 'End to end Automation Testing, Load Testing, Performance Testing, Backend system Testing.',
  },
  {
    num: '03',
    icon: icon3,
    iconHover: icon3h,
    title: 'Data Analytics and AI',
    desc: 'Data Visualization, Predictive Analysis, Personalization, Chatbots.',
  },
  {
    num: '04',
    icon: icon4,
    iconHover: icon4h,
    title: 'Embedded Application and Development',
    desc: 'Networked embedded systems, Mobile embedded systems, Stand alone embedded system.',
  },
  {
    num: '05',
    icon: icon5,
    iconHover: icon5h,
    title: 'Mobile App Development',
    desc: 'Android app, iOS app, React Native, Cross platform app — Flutter.',
  },
  {
    num: '06',
    icon: icon6,
    iconHover: icon6h,
    title: 'DevOps',
    desc: 'PaaS — Platform as a Service, IaaS — Infrastructure as a Service, System Integration.',
  },
];

function ServiceCard({ num, icon, iconHover, title, desc }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="col-12 col-sm-6 col-lg-4">
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          height: '100%',
          borderRadius: 16,
          padding: '2rem 1.75rem',
          background: hovered
            ? 'linear-gradient(135deg, #563D7C, #7b5ea7)'
            : '#fff',
          border: hovered
            ? '1px solid transparent'
            : '1px solid rgba(86,61,124,0.1)',
          boxShadow: hovered
            ? '0 12px 40px rgba(86,61,124,0.28)'
            : '0 2px 16px rgba(86,61,124,0.06)',
          transform: hovered ? 'translateY(-5px)' : 'translateY(0)',
          transition: 'all 1s ease',
          cursor: 'default',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        {/* Icon row */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              width: 52,
              height: 52,
              borderRadius: 14,
              background: hovered ? 'rgba(255,255,255,0.15)' : 'rgba(86,61,124,0.08)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background 0.25s',
            }}
          >
            <img
              src={hovered ? iconHover : icon}
              alt=""
              width={26}
              height={26}
              style={{ objectFit: 'contain', transition: 'opacity 0.2s' }}
            />
          </div>
          <span
            style={{
              fontSize: '2rem',
              fontWeight: 900,
              lineHeight: 1,
              color: hovered ? 'rgba(255,255,255,0.18)' : 'rgba(86,61,124,0.12)',
              fontFamily: "'Syne', sans-serif",
              transition: 'color 0.25s',
            }}
          >
            {num}
          </span>
        </div>

        {/* Title */}
        <h5
          style={{
            fontSize: '1rem',
            fontWeight: 700,
            color: hovered ? '#fff' : '#1a1a2e',
            lineHeight: 1.35,
            margin: 0,
            fontFamily: "'Syne', sans-serif",
            transition: 'color 0.25s',
          }}
        >
          {title}
        </h5>

        {/* Divider */}
        <div
          style={{
            height: 2,
            width: 32,
            borderRadius: 2,
            background: hovered ? 'rgba(255,255,255,0.35)' : 'rgba(86,61,124,0.2)',
            transition: 'background 0.25s',
          }}
        />

        {/* Description */}
        <p
          style={{
            fontSize: '0.855rem',
            color: hovered ? 'rgba(255,255,255,0.8)' : '#666',
            lineHeight: 1.75,
            margin: 0,
            fontFamily: "'Manrope', sans-serif",
            transition: 'color 0.25s',
          }}
        >
          {desc}
        </p>
      </div>
    </div>
  );
}

const Projectprogress = () => {
  return (
    <Element name="Services">
      <div className="bg-white py-5">
        <div className="container" style={{ maxWidth: 1100 }}>

          {/* Heading */}
          <div className="text-center mb-5">
            <p
              style={{
                fontSize: '0.7rem',
                fontWeight: 700,
                letterSpacing: '0.14em',
                textTransform: 'uppercase',
                color: '#563D7C',
                marginBottom: '0.5rem',
              }}
            >
              What we do
            </p>
            <h2
              style={{
                fontWeight: 800,
                color: '#1a1a2e',
                letterSpacing: '0.02em',
                fontFamily: "'Syne', sans-serif",
                marginBottom: '0.75rem',
              }}
            >
              Our Services
            </h2>
            <div
              style={{
                width: 48,
                height: 3,
                background: '#563D7C',
                borderRadius: 2,
                margin: '0 auto',
                opacity: 0.5,
              }}
            />
          </div>

          {/* Cards grid */}
          <div className="row g-4">
            {services.map((svc) => (
              <ServiceCard key={svc.num} {...svc} />
            ))}
          </div>

        </div>
      </div>
    </Element>
  );
};

export default Projectprogress;